import { gql } from '@apollo/client';

export const GET_REPORTING_PERIOD = gql`
  query GET_REPORTING_PERIOD($ids: [ID!], $state: State) {
    reportingPeriods(ids: $ids, state: $state) {
      id
      startDate
      endDate
      scheduledDeadline
      disabled
    }
  }
`;

export const GET_CURRENT_REPORTING_PERIOD = gql`
  query GET_CURRENT_REPORTING_PERIOD {
    currentReportingPeriod {
      id
      startDate
      endDate
      scheduledDeadline
      disabled
    }
  }
`;

export const ADD_REPORTING_PERIOD = gql`
  mutation ADD_REPORTING_PERIOD($input: AddReportingPeriodInput!) {
    addReportingPeriod(input: $input) {
      id
    }
  }
`;

export const UPDATE_REPORTING_PERIOD = gql`
  mutation UPDATE_REPORTING_PERIOD($input: UpdateReportingPeriodInput!) {
    updateReportingPeriod(input: $input) {
      id
    }
  }
`;

export const TOGGLE_DISABLED_REPORTING_PERIOD = gql`
  mutation TOGGLE_DISABLED_REPORTING_PERIOD($id: ID!) {
    toggleDisabledReportingPeriod(id: $id) {
      id
    }
  }
`;
